module.exports = __webpack_public_path__ + "img/2025-0416-02-01.a7a13774.png";